import { SSpinner, SUploadImagePreview, SUploadingWrapper } from './LifeStoriesBanner.styled'

export const OngoingUploadPlaceholder = (props: { src: string }) => (
  <SUploadingWrapper>
    <SUploadImagePreview src={props.src} alt="Image being uploaded" />
    <SSpinner />
  </SUploadingWrapper>
)
